import React, { useState } from 'react';
import { getManualSellPercents } from '../../utils/masterChefUtils';

const BTN_STYLES = {
  25: 'bg-yellow-900/40 text-yellow-300 border-yellow-700 hover:bg-yellow-900/60',
  50: 'bg-orange-900/40 text-orange-300 border-orange-700 hover:bg-orange-900/60',
  75: 'bg-amber-900/40 text-amber-300 border-amber-700 hover:bg-amber-900/60',
  100: 'bg-red-700 text-white border-red-600 hover:bg-red-600',
};

export default function ManualCloseButtons({
  position,
  exitConfig,
  onSell,
  onPositionUpdate,
  onClose,
  className = '',
}) {
  const [selling, setSelling] = useState(null);
  const isActive = position?.status === 'active' || position?.status === 'entering';
  if (!isActive || !onSell) return null;

  const percents = getManualSellPercents(position, exitConfig);

  const handleSell = async (pct) => {
    setSelling(pct);
    try {
      const updated = await onSell(position._id, pct);
      if (updated) onPositionUpdate?.(updated);
      if (pct === 100 || updated?.status === 'closed' || updated?.status === 'stopped') {
        onClose?.();
      }
    } finally {
      setSelling(null);
    }
  };

  return (
    <div className={`border-t border-gray-700 pt-3 mt-3 ${className}`}>
      <p className="text-xs text-gray-400 uppercase mb-2 tracking-wide">Manual close</p>
      <div className="grid grid-cols-2 gap-2">
        {percents.map((pct) => (
          <button
            key={pct}
            type="button"
            disabled={!!selling}
            onClick={() => handleSell(pct)}
            className={`px-2 py-2.5 text-sm font-semibold rounded-lg border transition-colors disabled:opacity-50 ${
              BTN_STYLES[pct] || 'bg-gray-800 text-gray-200 border-gray-600 hover:bg-gray-700'
            } ${pct === 100 ? 'col-span-2' : ''}`}
          >
            {selling === pct ? 'Selling…' : pct === 100 ? 'Close 100%' : `Sell ${pct}%`}
          </button>
        ))}
      </div>
      <p className="text-[10px] text-gray-500 mt-2">Sells % of remaining tokens</p>
    </div>
  );
}
